// **  Initial State
const initialState = {
  userData: {}
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, userData: action.data }
    case 'LOGOUT':
      return { ...state, userData: {} }
    case 'CURRENT_USER_UPDATED':
      return {...state, userData: {...state.userData, ...action.data}}
    default:
      return state
  }
}

export default authReducer
